module.exports = __webpack_public_path__ + "media/images/lb/392-b9e3833a8ca5a5c734a4571e1f095635.svg";